<template>
  <Teleport to="body">
    <Transition name="cookie-slide">
      <div v-if="visible" class="cookie-banner" role="dialog" aria-label="Cookie consent">
        <div class="cookie-banner__inner">
          <p class="cookie-banner__text">
            {{ t('cookieBanner.text') }}
            <NuxtLink :to="`/${locale}/privacy-policy`" class="cookie-banner__link">
              {{ t('cookieBanner.learnMore') }}
            </NuxtLink>
          </p>
          <div class="cookie-banner__actions">
            <button class="cookie-banner__btn cookie-banner__btn--accept" @click="onAccept">
              {{ t('cookieBanner.accept') }}
            </button>
            <button class="cookie-banner__btn cookie-banner__btn--decline" @click="onDecline">
              {{ t('cookieBanner.decline') }}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
const { t, locale } = useI18n()
const { accepted, accept, decline } = useCookieConsent()

const visible = computed(() => import.meta.client && accepted.value === null)

function onAccept() { accept() }
function onDecline() { decline() }
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: #1a1a2e;
  color: #fff;
  box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.25);
}

.cookie-banner__inner {
  max-width: var(--max-width-container, 1280px);
  margin: 0 auto;
  padding: 16px 40px;
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
}

.cookie-banner__text {
  flex: 1;
  font-size: 14px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.85);
  margin: 0;
}

.cookie-banner__link {
  color: #09AFEA;
  text-decoration: underline;
  white-space: nowrap;
}

.cookie-banner__actions {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
}

.cookie-banner__btn {
  padding: 8px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: opacity 0.2s;
}

.cookie-banner__btn:hover { opacity: 0.85; }

.cookie-banner__btn--accept {
  background: #09AFEA;
  color: #fff;
}

.cookie-banner__btn--decline {
  background: transparent;
  color: rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.25);
}

.cookie-slide-enter-active,
.cookie-slide-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.cookie-slide-enter-from,
.cookie-slide-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

@media (max-width: 767px) {
  .cookie-banner__inner {
    padding: 16px 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .cookie-banner__actions {
    width: 100%;
  }

  .cookie-banner__btn {
    flex: 1;
    text-align: center;
  }
}
</style>
